import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvConfigurationService } from './envconf.service';
import { Site } from '../models/site';
import { ApiService } from './api.service';
import { SiteSettings } from '../models/siteSettings';
import { StockSetting } from '../models/stockSetting';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/site`;

  /**
   * Constructor
   *
   * @param http httpClient
   *  @param apiService apiService
   */
  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}


  /**
   * Get all Sites by customer PK and name search
   *
   */
  listSitesByCustomer(idCustomer:number, nameSearch:string): Observable<Array<Site>> {
    return this.http.get<Array<Site>>(`${this.endpoint}?idCustomer=${idCustomer}&siteName=${nameSearch}`);
  }

  /**
   * Get all Sites by User PK and name search
   *
   */
  listSitesByUserId(idUser:string, nameSearch:string): Observable<Array<Site>> {
    return this.http.get<Array<Site>>(`${this.endpoint}?idUser=${idUser}&siteName=${nameSearch}`);
  }

  getSizeSettings(mineId: number): Observable<SiteSettings> {
    return this.http.get<SiteSettings>(`${this.endpoint}/stock/settings?siteId=${mineId}`);
  }

  saveSizeSettings(siteId: number, stockSizeSettings: StockSetting[]): Observable<any> {
    return this.http.put<Array<Site>>(`${this.endpoint}/stock/settings`, { siteId, stockSizeSettings });
  }

}
